export const LoanSelfServicesModal = () => {
	return (
		<div>
			<p className="body negro-general" style={{ marginBottom: 16 }}>
				Completa algunos datos y
				<span className="body-bold negro-general">
					{' '}
					conoce el valor de la cuota de tu crédito automotriz.
				</span>
			</p>
			<div style={{ marginBottom: 32 }}>
				<p className="body-bold primary-color" style={{ marginBottom: 16 }}>
					Autogestionar tu crédito es:
				</p>
				<ul style={{ marginLeft: 24 }} className="gris-6">
					<li>
						<span className="body-bold primary-color">Rápido</span>, porque te evaluamos antes de
						que te llame un ejecutivo.
					</li>
					<li>
						<span className="body-bold primary-color">Conveniente</span>, porque te damos un
						descuento en tu tasa.
					</li>
				</ul>
			</div>
			<div style={{ marginBottom: 16 }}>
				<p className="body-bold primary-color" style={{ marginBottom: 16 }}>
					{' '}
					Debes tener a mano la siguiente documentación:
				</p>
				<p className="body-bold gris-6" style={{ marginBottom: 16 }}>
					Trabajador dependiente
				</p>
				<ul style={{ marginLeft: 24, marginBottom: 16 }}>
					<li>3 últimas liquidaciónes de sueldo.</li>
					<li>Comprobante de domicilio (Ej: cuenta luz, agua, internet).</li>
					<li>12 cotizaciones de afp con Rut del empleador.</li>
				</ul>
				<p className="body-bold gris-6" style={{ marginBottom: 16 }}>
					Trabajador independiente
				</p>
				<ul style={{ marginLeft: 24 }}>
					<li>Carpeta Tributaria <span className="primary-color">(necesitarás tu clave única de SII)</span>.</li>
					<li>Comprobante de domicilio (Ej: cuenta luz, agua, internet).</li>
				</ul>
			</div>
		</div>
	);
};
